export default __webpack_public_path__ + "static/media/admin.03346702.svg";